import { SubPageLayout } from "@/components/SubPageLayout";
import { SITE_IMAGES } from "@/lib/site-data";

export default function KarpitosBorozes() {
  return (
    <SubPageLayout
      eyebrow="Kárpitos és bőrözési munkák"
      title="Belsőtér, ülés, kabrió tető."
      intro="Járműbelsők kárpitozása, kabriótetők készítése és cseréje, ülések bőrözése. A kárpitos munkáinknál a ponyvához hasonlóan ugyanazt a precíz, hegesztett és varrott kivitelezést vállaljuk."
      heroImage="/assets/gallery/egyedi-01.jpg"
      bullets={[
        { title: "Kabriótető", text: "Csere vagy új gyártása, méretpontos PVC vagy textil kivitelben." },
        { title: "Üléskárpit", text: "Veterán és modern járművekhez – eredetihez hű, vagy egyedi." },
        { title: "Belsőtér bőrözés", text: "Kormány, ajtókárpit, könyöktámasz." },
        { title: "Egyedi mintázat", text: "Választható szín, varrás minta és anyag-kombinációk." },
      ]}
      gallery={SITE_IMAGES.upholsteryGallery}
    />
  );
}
